import { useEffect, useRef, useState } from 'react';

import { IconGear } from '../../../common/icons';

import '../styles/sales.css';

// Menú de acciones por fila (Ventas): botón engranaje (gira al abrir/hover) que despliega
// un dropdown con las acciones. Se cierra al hacer click fuera o al hacer scroll.
//
// El dropdown va en position:fixed calculado desde el botón porque la tarjeta de la tabla
// usa overflow:hidden (un absolute quedaría recortado). Como no hay ancestro con transform
// (los modales usan fixed inset:0 y cubren la ventana), fixed queda relativo al viewport y
// escapa el recorte, sin dejar de ser hijo del root para detectar el click-fuera.
export default function SaleRowActions({ children, disabled }) {
    const [open, setOpen] = useState(false);
    const [coords, setCoords] = useState(null);
    const rootRef = useRef(null);
    const triggerRef = useRef(null);

    const toggle = () => {
        if (open) { setOpen(false); return; }
        if (triggerRef.current) {
            const r = triggerRef.current.getBoundingClientRect();
            setCoords({ top: r.bottom + 4, right: window.innerWidth - r.right });
        }
        setOpen(true);
    };

    useEffect(() => {
        if (!open) return;
        const onPointerDown = (e) => { if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false); };
        const close = () => setOpen(false);
        // scroll con capture: atrapa el scroll de cualquier contenedor, no solo el de window.
        document.addEventListener('pointerdown', onPointerDown);
        window.addEventListener('scroll', close, true);
        window.addEventListener('resize', close);
        return () => {
            document.removeEventListener('pointerdown', onPointerDown);
            window.removeEventListener('scroll', close, true);
            window.removeEventListener('resize', close);
        };
    }, [open]);

    return (
        <div className="sale-menu" ref={rootRef}>
            <button
                ref={triggerRef}
                type="button"
                className={`sale-icon sale-menu__trigger ${open ? 'sale-menu__trigger--open' : ''}`}
                onClick={toggle}
                disabled={disabled}
                aria-haspopup="menu"
                aria-expanded={open}
                aria-label="Opciones de la venta"
                title="Opciones"
            >
                <IconGear />
            </button>
            {open && coords && (
                <div
                    className="sale-menu__dropdown"
                    role="menu"
                    style={{ top: `${coords.top}px`, right: `${coords.right}px` }}
                    onClick={() => setOpen(false)}
                >
                    {children}
                </div>
            )}
        </div>
    );
}
